import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, TabPageProps } from "@saleor/types";
import { ListProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { CustomerInfo_customerInfo_edges_node } from "../../types/CustomerInfo";
import CustomerInfoList from "../CustomerInfoList";
import {
  createFilterStructure,
  CustomerInfoFilterKeys,
  CustomerInfoListFilterOpts
} from "./filters";

interface CustomerListPageProp
  extends ListProps,
    FilterPageProps<CustomerInfoFilterKeys, CustomerInfoListFilterOpts>,
    TabPageProps {
  customers: CustomerInfo_customerInfo_edges_node[];
  onBack: () => void;
  download: () => void;
}

const CustomerInfoListPage: React.FC<CustomerListPageProp> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onAll,
  onFilterChange,
  onSearchChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  customers,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Customer Information">
          <Button
            color="primary"
            variant="contained"
            disabled={!customers}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            filterStructure={structure}
            initialSearch={initialSearch}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search by Email or Name"
            })}
            tabs={tabs}
            onAll={onAll}
            onFilterChange={onFilterChange}
            onSearchChange={onSearchChange}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <CustomerInfoList customers={customers} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default CustomerInfoListPage;
